'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventListItem = function (_Component) {
  _inherits(EventListItem, _Component);

  function EventListItem(props) {
    _classCallCheck(this, EventListItem);

    var _this = _possibleConstructorReturn(this, (EventListItem.__proto__ || Object.getPrototypeOf(EventListItem)).call(this));

    _moment2.default.locale(props.locale);
    return _this;
  }

  _createClass(EventListItem, [{
    key: 'render',
    value: function render() {
      if (this.props.children) {
        return this.props.children;
      }

      var _props = this.props,
          event = _props.event,
          placeholderImage = _props.placeholderImage;

      var Link = _config2.default.config().linkComponent;

      var date = (0, _moment2.default)(event[this.props.linkDate]);
      var query = {
        date: date.format('YYYY-MM-DD_HH-mm-ss')
      };
      var itemAttributes = { className: 'EventListItem ' + this.props.layout + ' ' + this.props.size };

      if (this.props.layout === 'grid' || this.props.layout === 'carousel') {
        var imageUrl = event.display_image_url || placeholderImage;
        if (imageUrl) {
          itemAttributes.style = { backgroundImage: 'url(' + imageUrl + ')' };
        }
      }

      var timeAttributes = {
        children: this.props.dateFormat(event)
      };

      function getListImage() {
        return placeholderImage || event.display_image_url;
      }

      return _react2.default.createElement(
        'article',
        itemAttributes,
        _react2.default.createElement(
          Link,
          { to: { pathname: '/evenements/' + event.slug + '/' + event.id, query: query } },
          _react2.default.createElement(
            'div',
            null,
            this.props.layout === 'list' && getListImage() && _react2.default.createElement('img', { alt: event.title, src: getListImage() }),
            _react2.default.createElement('time', _extends({ dateTime: date.format('YYYY-MM-DDTHH:mm') }, timeAttributes)),
            _react2.default.createElement(
              'div',
              { className: 'info' },
              _react2.default.createElement(
                'h1',
                null,
                event.title
              ),
              event.venue && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  { className: 'venue' },
                  event.venue.name
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EventListItem;
}(_react.Component);

EventListItem.propTypes = {
  /** Child DOM elements provided as a custom item template. */
  children: _propTypes2.default.object,
  /** Method used to display the date and time. */
  dateFormat: _propTypes2.default.func,
  /** Event object in the Caligram API format. */
  event: _propTypes2.default.object.isRequired,
  /** Format event to be displayed as part of a linear list, a grid, or a carousel. */
  layout: _propTypes2.default.oneOf(['list', 'grid', 'carousel']),
  /** Date property to use for link generation. */
  linkDate: _propTypes2.default.string,
  /** [Moment](https://momentjs.com/docs/#/i18n/) locale string */
  locale: _propTypes2.default.string,
  /** Placeholder image to be used when the event has no image. */
  placeholderImage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  /** Display size of the event. Only used for the grid layout. */
  size: _propTypes2.default.oneOf(['small', 'normal'])
};
EventListItem.defaultProps = {
  children: null,
  dateFormat: function dateFormat(event) {
    var nextDate = event.next_date,
        startDate = event.start_date;

    return _react2.default.createElement(
      'span',
      null,
      (0, _moment2.default)(nextDate || startDate).format('H [h] mm')
    );
  },
  layout: 'list',
  linkDate: 'start_date',
  locale: _config2.default.config().locale,
  placeholderImage: null,
  size: 'normal'
};
exports.default = EventListItem;
EventListItem.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventListItem',
  'props': {
    'children': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': 'Child DOM elements provided as a custom item template.'
    },
    'dateFormat': {
      'defaultValue': {
        'value': '(event) => {\n  const { next_date: nextDate, start_date: startDate } = event;\n  return (<span>{moment(nextDate || startDate).format(\'H [h] mm\')}</span>);\n}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Method used to display the date and time.'
    },
    'layout': {
      'defaultValue': {
        'value': '\'list\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'list\'',
          'computed': false
        }, {
          'value': '\'grid\'',
          'computed': false
        }, {
          'value': '\'carousel\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Format event to be displayed as part of a linear list, a grid, or a carousel.'
    },
    'linkDate': {
      'defaultValue': {
        'value': '\'start_date\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Date property to use for link generation.'
    },
    'locale': {
      'defaultValue': {
        'value': 'CaligramReact.config().locale',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](https://momentjs.com/docs/#/i18n/) locale string'
    },
    'placeholderImage': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'object'
        }]
      },
      'required': false,
      'description': 'Placeholder image to be used when the event has no image.'
    },
    'size': {
      'defaultValue': {
        'value': '\'normal\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'small\'',
          'computed': false
        }, {
          'value': '\'normal\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Display size of the event. Only used for the grid layout.'
    },
    'event': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': 'Event object in the Caligram API format.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventListItem.js
// module id = 182
// module chunks = 0